const pluralize = (count: number, singular: string, plural: string): string => (count > 1 ? plural : singular);

export {
    pluralize
};

